import { z } from "zod";
import {
  baseToolPatchPayloadSchema,
  baseToolPostPayloadSchema
} from "./base.js";
const CallEndToolType = "call_end";
const callEndToolSettingsSchema = z.object({
  // No additional settings required for call end
  // The tool will simply hang up the Twilio call
});
const callEndToolPostPayloadSchema = baseToolPostPayloadSchema.extend({
  type: z.literal(CallEndToolType),
  settings: callEndToolSettingsSchema
});
const callEndToolPatchPayloadSchema = baseToolPatchPayloadSchema.extend({
  type: z.literal(CallEndToolType),
  settings: callEndToolSettingsSchema.optional()
});
export {
  CallEndToolType,
  callEndToolPatchPayloadSchema,
  callEndToolPostPayloadSchema,
  callEndToolSettingsSchema
};
//# sourceMappingURL=callEnd.js.map
